import { create } from "zustand";

const AdminZustandStore = create((set) => ({
  checked: {
    Project: [],
    Keyword: [],
    Paid: [],
    Plan: [],
    Tool: [],
    "Last Login": [],
  },
  setChecked: (key, value) =>
    set((state) => {
      const currentValues = state.checked[key] || [];
      return {
        checked: {
          ...state.checked,
          [key]: currentValues.includes(value)
            ? currentValues.filter((item) => item !== value) // Remove value
            : [...currentValues, value], // Add value
        },
      };
    }),

  resetChecked: () =>
    set({
      checked: {
        Project: [],
        Keyword: [],
        Paid: [],
        Plan: [],
        Tool: [],
        "Last Login": [],
      },
    }),

  // User filter
  filterByDate: {
    filter: false,
    date: "",
    data: [],
  },
  setFilterByDate: (filter, date, data) =>
    set({
      filterByDate: { filter, date, data },
    }),

  resetFilterByDate: () =>
    set({
      filterByDate: {
        filter: false,
        date: "",
        data: [],
      },
    }),

  // guest post
  guestPost: {
    data: [],
    loading: true,
    error: null,
  },

  // agency data
  allAgencyData: {
    data: [],
    loading: true,
    error: null,
  },
}));

export default AdminZustandStore;
